// @flow
import type { NextCtx } from '@globalTypes';
import { getAccessToken } from './cookie';

export const getHeaders = (nextCtx: NextCtx) => ({
  ...getAuthorizationHeader(nextCtx),
  ...getLanguageHeaders()
});

export const getAuthorizationHeader = ({ req }: NextCtx) => {
  const accessToken: ?string = getAccessToken(req);

  if (accessToken) {
    return { Authorization: `Bearer ${accessToken}` };
  }

  return {};
};

export const getLanguageHeaders = () => {
  const language: string = 'en';

  return {
    'Accept-Language': language
  };
};
